import { render, staticRenderFns } from "./delGoods.vue?vue&type=template&id=9dcb1b28&"
import script from "./delGoods.vue?vue&type=script&lang=js&"
export * from "./delGoods.vue?vue&type=script&lang=js&"
import style0 from "./delGoods.vue?vue&type=style&index=0&id=9dcb1b28&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dcb1b28')) {
      api.createRecord('9dcb1b28', component.options)
    } else {
      api.reload('9dcb1b28', component.options)
    }
    module.hot.accept("./delGoods.vue?vue&type=template&id=9dcb1b28&", function () {
      api.rerender('9dcb1b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/delGoods.vue"
export default component.exports